export function axBoxIdentity(args) {
    return args[0];
}
